"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10.854 5.146a.5.5 0 0 0-.708.708L11.293 7H8a5 5 0 0 0 0 10h.5a.5.5 0 0 0 0-1H8a4 4 0 0 1 0-8h3.293l-1.147 1.146a.5.5 0 0 0 .708.708L13.207 7.5zm2.292 13.708a.5.5 0 0 0 .708-.708L12.707 17H16a5 5 0 0 0 0-10h-.5a.5.5 0 0 0 0 1h.5a4 4 0 0 1 0 8h-3.293l1.147-1.146a.5.5 0 0 0-.708-.708L10.793 16.5z"
}), 'ReplaceRound');
//# sourceMappingURL=index.js.map